export default __webpack_public_path__ + "Roboto2.png";